(function (Lfl, $, undefined) {
    /**
     * Object responsible for javascript file related checks - e.g. if certain file is loaded already.
     *
     * @memberOf Lfl
     */
     Lfl.Files;

    (function (Files, $, undefined) {
        /**
         * @memberOf Lfl.Files
         * @param namespace The namespace into which the file belongs.
         * @param fileId An unique identifier of this file in it's namespace.
         * @return {boolean}
         */
        Files.isLoadedFirstTime = function(namespace, fileId) {
            if(namespace.timesLoaded === undefined) {
                namespace.timesLoaded = [];
            }

            if (typeof fileId === 'undefined' || fileId.trim() == "") {
                throw("The provided fileId seems to be empty, which is generally an error.\n" +
                "Please provide a meaningful and unique identifier. \n" +
                "FileId='" + fileId + "' and namespace='" + JSON.stringify(namespace, null, 4)+ "'\n");
            }

            var isFirst = (false === _.has(namespace.timesLoaded, fileId));

            if(isFirst) {
                namespace.timesLoaded[fileId] = 1;
            } else {
                namespace.timesLoaded[fileId]++;
            }

            if (!isFirst) {
                console.warn(
                    "Warning: Javascript file for component with identifier \"" + fileId + "\" is included " +  namespace.timesLoaded[fileId] + " times.");
            }

            return isFirst;
        };

        /**
         * @memberOf Lfl.Files
         * @param namespace The namespace into which the file belongs.
         * @param fileId An unique identifier of this file in it's namespace.
         * @return {boolean}
         */
        Files.isLoadedAlready = function(namespace, fileId) {
            return false === Files.isLoadedFirstTime(namespace, fileId);
        };
    }(Lfl.Files = Lfl.Files || {}, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
